import Tooltip from "@mui/material/Tooltip";
import { ToolbarButton } from "@mui/x-data-grid";
import { Toolbar } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import React from "react";
import { openDialog } from "../../../store/slices/dialog/dialogSlice";
import { useDispatch } from "react-redux";
import { CREATE_DAYOFF } from "../../../store/slices/utils/dialogEnum";

function CustomToolbar() {
  const dispatch = useDispatch();
  return (
    <Toolbar>
      <Tooltip title="Add new commodity">
        <ToolbarButton
          aria-describedby="new-panel"
          onClick={() => dispatch(openDialog(CREATE_DAYOFF))}
        >
          <AddIcon fontSize="large" />
        </ToolbarButton>
      </Tooltip>
    </Toolbar>
  );
}

export default CustomToolbar;
